// Auto generated file, please don't edit manually

import { UIConfig } from "../UIConfig"
import { NamespaceId } from "../Config"
import { Metrics } from "../Metrics"
import { StringEditor, EnumEditor, NumberEditor, BoolEditor } from "../editor"
import dayjs from "dayjs"
import * as metricsProto from "edge-proto/dist/edge/v1/metrics"
import { PathResult, pathErrorInit, pathErrorAddPrefix, pathSuccessInit } from "../PathError"
import { LogLevel, LogLevelMapper } from "../Logs"

export type FanControlMode = "off" | "auto" | "max" | "manual"
export type WifiSecurity = "open" | "wpa-psk" | "wpa2-psk" | "wpa3-psk"

export interface DeviceConfigMotion<T> {
  useAdminPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined
  useBeamInfoId(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useFanControlMode(extraData: T, namespace?: NamespaceId): EnumEditor<FanControlMode> | undefined
  useManualFanSpeedInternal1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedInternal2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedExternal1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedExternal2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedPb1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedPb2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedBuc1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualFanSpeedBuc2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualPositionEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined
  useManualPositionLat(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useManualPositionLon(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useModemUserPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined
  useSoftwareUpdateCheckEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined
  useTransmissionIntentEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined
  useWifiEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined
  useWifiTxPower(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useWifiChannel(extraData: T, namespace?: NamespaceId): NumberEditor | undefined
  useWifiSsid(extraData: T, namespace?: NamespaceId): StringEditor | undefined
  useWifiBroadcastSsid(extraData: T, namespace?: NamespaceId): BoolEditor | undefined
  useWifiSecurity(extraData: T, namespace?: NamespaceId): EnumEditor<WifiSecurity> | undefined
  useWifiPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined
}

export function newDeviceConfigMotion<T>(uiConfig: UIConfig<T>): DeviceConfigMotion<T> {
  return {
    useAdminPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined {
      return uiConfig.useStringValue("admin_password", extraData, namespace)
    },
    useBeamInfoId(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("beam_info_id", extraData, namespace)
    },
    useFanControlMode(extraData: T, namespace?: NamespaceId): EnumEditor<FanControlMode> | undefined {
      return uiConfig.useEnumValue("fan_control_mode", extraData, namespace)
    },
    useManualFanSpeedInternal1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_internal1", extraData, namespace)
    },
    useManualFanSpeedInternal2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_internal2", extraData, namespace)
    },
    useManualFanSpeedExternal1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_external1", extraData, namespace)
    },
    useManualFanSpeedExternal2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_external2", extraData, namespace)
    },
    useManualFanSpeedPb1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_pb1", extraData, namespace)
    },
    useManualFanSpeedPb2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_pb2", extraData, namespace)
    },
    useManualFanSpeedBuc1(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_buc1", extraData, namespace)
    },
    useManualFanSpeedBuc2(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_fan_speed_buc2", extraData, namespace)
    },
    useManualPositionEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined {
      return uiConfig.useBoolValue("manual_position_enabled", extraData, namespace)
    },
    useManualPositionLat(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_position_lat", extraData, namespace)
    },
    useManualPositionLon(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("manual_position_lon", extraData, namespace)
    },
    useModemUserPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined {
      return uiConfig.useStringValue("modem_user_password", extraData, namespace)
    },
    useSoftwareUpdateCheckEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined {
      return uiConfig.useBoolValue("software_update_check_enabled", extraData, namespace)
    },
    useTransmissionIntentEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined {
      return uiConfig.useBoolValue("transmission_intent_enabled", extraData, namespace)
    },
    useWifiEnabled(extraData: T, namespace?: NamespaceId): BoolEditor | undefined {
      return uiConfig.useBoolValue("wifi_enabled", extraData, namespace)
    },
    useWifiTxPower(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("wifi_tx_power", extraData, namespace)
    },
    useWifiChannel(extraData: T, namespace?: NamespaceId): NumberEditor | undefined {
      return uiConfig.useNumberValue("wifi_channel", extraData, namespace)
    },
    useWifiSsid(extraData: T, namespace?: NamespaceId): StringEditor | undefined {
      return uiConfig.useStringValue("wifi_ssid", extraData, namespace)
    },
    useWifiBroadcastSsid(extraData: T, namespace?: NamespaceId): BoolEditor | undefined {
      return uiConfig.useBoolValue("wifi_broadcast_ssid", extraData, namespace)
    },
    useWifiSecurity(extraData: T, namespace?: NamespaceId): EnumEditor<WifiSecurity> | undefined {
      return uiConfig.useEnumValue("wifi_security", extraData, namespace)
    },
    useWifiPassword(extraData: T, namespace?: NamespaceId): StringEditor | undefined {
      return uiConfig.useStringValue("wifi_password", extraData, namespace)
    },
  }
}

export type BeamListEntry = {
  id: number
  name: string
}
export type BeamList = BeamListEntry[]
export type CarrierPolarization = "H" | "V"
export type DiagnosticsHealth = "Healthy" | "Degraded" | "Critical" | "Unknown"

export interface DeviceMetricsMotion {
  useAntennaPositionLat(): number | undefined
  useAntennaPositionLon(): number | undefined
  useBeamInfoId(): number | undefined
  useBeamList(): BeamList | undefined
  useBoardTemperaturesTimestamp(): dayjs.Dayjs | undefined
  useBoardTemperaturesPbTemperature(): number | undefined
  useBoardTemperaturesPwbTemperature(): number | undefined
  useBoardTemperaturesTbbTemperature(): number | undefined
  useBoardTemperaturesCpuTemperature(): number | undefined
  useBoardTemperaturesSocTemperature(): number | undefined
  useBucInfoSwVersion(): number | undefined
  useBucInfoHwVersion(): number | undefined
  useBucInfoSerialNumber(): number | undefined
  useBucInfoMuted(): boolean | undefined
  useBucInfoHardMuted(): boolean | undefined
  useBucTelemetriesTimestamp(): dayjs.Dayjs | undefined
  useBucTelemetriesTempSensor1(): number | undefined
  useBucTelemetriesTempSensor2(): number | undefined
  useBucTelemetriesTempSensorCtrl(): number | undefined
  useBucTelemetriesVoltage(): number | undefined
  useBucTelemetriesCurrent(): number | undefined
  useCarrierRxLo(): number | undefined
  useCarrierTxLo(): number | undefined
  useCarrierCarrier(): number | undefined
  useCarrierBandwidth(): number | undefined
  useCarrierPolSkew(): number | undefined
  useCarrierPolarization(): CarrierPolarization | undefined
  useConnectivityPing(): boolean | undefined
  useConnectivityDns(): boolean | undefined
  useConnectivityTimestamp(): dayjs.Dayjs | undefined
  useCurrentOrientationAzimuth(): number | undefined
  useCurrentOrientationElevation(): number | undefined
  useCurrentOrientationPolarization(): number | undefined
  useDiagnosticsHealth(): DiagnosticsHealth | undefined
  useFanSpeedsTimestamp(): dayjs.Dayjs | undefined
  useFanSpeedsPbFan1(): number | undefined
  useFanSpeedsPbFan2(): number | undefined
  useFanSpeedsPwbFan1(): number | undefined
  useFanSpeedsPwbFan2(): number | undefined
  useFanSpeedsPwbFan3(): number | undefined
  useFanSpeedsPwbFan4(): number | undefined
  useFanSpeedsTbbFan1(): number | undefined
  useFanSpeedsTbbFan2(): number | undefined
  useGnssSatellites(): number | undefined
  useGnssPositionLat(): number | undefined
  useGnssPositionLon(): number | undefined
  useLnbInfoSwVersion(): number | undefined
  useLnbInfoHwVersion(): number | undefined
  useLnbInfoSerialNumber(): number | undefined
  useLnbInfoMuted(): boolean | undefined
  useLnbTelemetriesTimestamp(): dayjs.Dayjs | undefined
  useLnbTelemetriesTempSensor1(): number | undefined
  useLnbTelemetriesTempSensorCtrl(): number | undefined
  useLnbTelemetriesVoltage(): number | undefined
  useLnbTelemetriesCurrent(): number | undefined
  useModemInfoSerial(): number | undefined
  useModemInfoSoftware(): string | undefined
  useModemInfoPlatform(): string | undefined
  useModemInfoBoard(): string | undefined
  useModemSignalStrength(): number | undefined
  useModemStatusStrength(): number | undefined
  useModemStatusRxLocked(): boolean | undefined
  useMotorDiagnosticsAlphaTimestamp(): dayjs.Dayjs | undefined
  useMotorDiagnosticsAlphaSpeed(): number | undefined
  useMotorDiagnosticsAlphaCurrent(): number | undefined
  useMotorDiagnosticsAlphaWindingTemp(): number | undefined
  useMotorDiagnosticsAlphaDriveThermalState(): number | undefined
  useMotorDiagnosticsAlphaMotorThermalState(): number | undefined
  useMotorDiagnosticsBetaTimestamp(): dayjs.Dayjs | undefined
  useMotorDiagnosticsBetaSpeed(): number | undefined
  useMotorDiagnosticsBetaCurrent(): number | undefined
  useMotorDiagnosticsBetaWindingTemp(): number | undefined
  useMotorDiagnosticsBetaDriveThermalState(): number | undefined
  useMotorDiagnosticsBetaMotorThermalState(): number | undefined
  useMotorLocalOrientationAlpha(): number | undefined
  useMotorLocalOrientationBeta(): number | undefined
  usePbVoltagesTimestamp(): dayjs.Dayjs | undefined
  usePbVoltagesDig24v(): number | undefined
  usePbVoltagesDig5v(): number | undefined
  usePbVoltagesDig3v3(): number | undefined
  usePbVoltagesDig1v8(): number | undefined
  usePbVoltagesDig1v2(): number | undefined
  usePbVoltagesPow5v(): number | undefined
  usePbVoltagesPow3v3(): number | undefined
  usePbVoltagesPow48v(): number | undefined
  usePbVoltagesPowEpos(): number | undefined
  usePbVoltagesPowTbb(): number | undefined
  usePowerDetectorStrength(): number | undefined
  usePwbMetricsTimestamp(): dayjs.Dayjs | undefined
  usePwbMetricsPow48v(): number | undefined
  usePwbMetricsPow3v3(): number | undefined
  usePwbMetricsCurrentSense(): number | undefined
  usePwbMetricsEnableOutput(): boolean | undefined
  usePwbMetricsFault(): boolean | undefined
  usePwbMetricsButtonPressed(): boolean | undefined
  useSatellitePositionLat(): number | undefined
  useSatellitePositionLon(): number | undefined
  useSystemTimeTimestamp(): dayjs.Dayjs | undefined
  useSoftwareUpdateAvailableStatus(): boolean | undefined
  useTargetLocalOrientationAlpha(): number | undefined
  useTargetLocalOrientationBeta(): number | undefined
  useTargetLocalOrientationGamma(): number | undefined
  useTargetOrientationAzimuth(): number | undefined
  useTargetOrientationElevation(): number | undefined
  useTargetOrientationPolarization(): number | undefined
  useTbbMetricsTimestamp(): dayjs.Dayjs | undefined
  useTbbMetricsPow48v(): number | undefined
  useTbbMetricsPow25v(): number | undefined
  useTbbMetricsPow12v(): number | undefined
  useTbbMetricsPow3v3(): number | undefined
  useTbbMetricsCurrentSense(): number | undefined
  useTbbMetricsBucCurrent(): number | undefined
  useTbbMetricsLnbCurrent(): number | undefined
}

export function newDeviceMetricsMotion(metrics: Metrics) {
  return {
    useAntennaPositionLat(): number | undefined {
      return metrics.useNumberValue("antenna_position", "lat")
    },
    useAntennaPositionLon(): number | undefined {
      return metrics.useNumberValue("antenna_position", "lon")
    },
    useBeamInfoId(): number | undefined {
      return metrics.useNumberValue("beam_info", "id")
    },
    useBeamList(): BeamList | undefined {
      const beamListEntryId = (value: metricsProto.MetricValue): PathResult<number> => {
        const metricValue = value.value
        switch (metricValue?.$case) {
          case "uint32Value": {
            return pathSuccessInit(metricValue.uint32Value)
          }
          default: {
            return pathErrorInit(`Expected uint type but got ${metricValue?.$case}`, "")
          }
        }
      }
      const beamListEntryName = (value: metricsProto.MetricValue): PathResult<string> => {
        const metricValue = value.value
        switch (metricValue?.$case) {
          case "stringValue": {
            return pathSuccessInit(metricValue.stringValue)
          }
          default: {
            return pathErrorInit(`Expected string type but got ${metricValue?.$case}`, "")
          }
        }
      }
      const beamListEntry = (value: metricsProto.MetricValue): PathResult<BeamListEntry> => {
        const metricValue = value.value
        switch (metricValue?.$case) {
          case "objectValue": {
            const fields = metricValue.objectValue.entries
            // id
            const idMessage = fields.find((field: metricsProto.KVMetricValue) => field.id == "id")
            if (idMessage === undefined) {
              return pathErrorInit("object field could not be found", "id")
            }
            if (idMessage.value === undefined) {
              return pathErrorInit("proto kvmetric has undefined value", "id")
            }
            const id = beamListEntryId(idMessage.value)
            if (id.type === "error") {
              return pathErrorAddPrefix(id, "id")
            }
            // name
            const nameMessage = fields.find((field: metricsProto.KVMetricValue) => field.id == "name")
            if (nameMessage === undefined) {
              return pathErrorInit("object field could not be found", "name")
            }
            if (nameMessage.value === undefined) {
              return pathErrorInit("proto kvmetric has undefined value", "name")
            }
            const name = beamListEntryName(nameMessage.value)
            if (name.type === "error") {
              return pathErrorAddPrefix(name, "name")
            }
            return pathSuccessInit({
              id: id.value,
              name: name.value,
            })
          }
          default: {
            return pathErrorInit(`Expected object type but got ${metricValue?.$case}`, "")
          }
        }
      }
      const beamList = (value: metricsProto.MetricValue): PathResult<BeamList> => {
        const metricValue = value.value
        switch (metricValue?.$case) {
          case "listValue": {
            const values: BeamList = []
            for (let i = 0; i < metricValue.listValue.values.length; i++) {
              const mappedValue = beamListEntry(metricValue.listValue.values[i])
              if (mappedValue.type === "error") {
                return pathErrorAddPrefix(mappedValue, `[${i}]`)
              }
              values.push(mappedValue.value)
            }
            return pathSuccessInit(values)
          }
          default: {
            return pathErrorInit(`Expected list type but got ${metricValue?.$case}`, "")
          }
        }
      }
      const parser = (value: metricsProto.MetricValue) => beamList(value)
      return metrics.useProtoValue("beam_list", "list", parser)
    },
    useBoardTemperaturesTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("board_temperatures", "timestamp")
    },
    useBoardTemperaturesPbTemperature(): number | undefined {
      return metrics.useNumberValue("board_temperatures", "pb_temperature")
    },
    useBoardTemperaturesPwbTemperature(): number | undefined {
      return metrics.useNumberValue("board_temperatures", "pwb_temperature")
    },
    useBoardTemperaturesTbbTemperature(): number | undefined {
      return metrics.useNumberValue("board_temperatures", "tbb_temperature")
    },
    useBoardTemperaturesCpuTemperature(): number | undefined {
      return metrics.useNumberValue("board_temperatures", "cpu_temperature")
    },
    useBoardTemperaturesSocTemperature(): number | undefined {
      return metrics.useNumberValue("board_temperatures", "soc_temperature")
    },
    useBucInfoSwVersion(): number | undefined {
      return metrics.useNumberValue("buc_info", "sw_version")
    },
    useBucInfoHwVersion(): number | undefined {
      return metrics.useNumberValue("buc_info", "hw_version")
    },
    useBucInfoSerialNumber(): number | undefined {
      return metrics.useNumberValue("buc_info", "serial_number")
    },
    useBucInfoMuted(): boolean | undefined {
      return metrics.useBoolValue("buc_info", "muted")
    },
    useBucInfoHardMuted(): boolean | undefined {
      return metrics.useBoolValue("buc_info", "hard_muted")
    },
    useBucTelemetriesTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("buc_telemetries", "timestamp")
    },
    useBucTelemetriesTempSensor1(): number | undefined {
      return metrics.useNumberValue("buc_telemetries", "temp_sensor_1")
    },
    useBucTelemetriesTempSensor2(): number | undefined {
      return metrics.useNumberValue("buc_telemetries", "temp_sensor_2")
    },
    useBucTelemetriesTempSensorCtrl(): number | undefined {
      return metrics.useNumberValue("buc_telemetries", "temp_sensor_ctrl")
    },
    useBucTelemetriesVoltage(): number | undefined {
      return metrics.useNumberValue("buc_telemetries", "voltage")
    },
    useBucTelemetriesCurrent(): number | undefined {
      return metrics.useNumberValue("buc_telemetries", "current")
    },
    useCarrierRxLo(): number | undefined {
      return metrics.useNumberValue("carrier", "rx_lo")
    },
    useCarrierTxLo(): number | undefined {
      return metrics.useNumberValue("carrier", "tx_lo")
    },
    useCarrierCarrier(): number | undefined {
      return metrics.useNumberValue("carrier", "carrier")
    },
    useCarrierBandwidth(): number | undefined {
      return metrics.useNumberValue("carrier", "bandwidth")
    },
    useCarrierPolSkew(): number | undefined {
      return metrics.useNumberValue("carrier", "pol_skew")
    },
    useCarrierPolarization(): CarrierPolarization | undefined {
      return metrics.useEnumValue("carrier", "polarization")
    },
    useConnectivityPing(): boolean | undefined {
      return metrics.useBoolValue("connectivity", "ping")
    },
    useConnectivityDns(): boolean | undefined {
      return metrics.useBoolValue("connectivity", "dns")
    },
    useConnectivityTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("connectivity", "timestamp")
    },
    useCurrentOrientationAzimuth(): number | undefined {
      return metrics.useNumberValue("current_orientation", "azimuth")
    },
    useCurrentOrientationElevation(): number | undefined {
      return metrics.useNumberValue("current_orientation", "elevation")
    },
    useCurrentOrientationPolarization(): number | undefined {
      return metrics.useNumberValue("current_orientation", "polarization")
    },
    useDiagnosticsHealth(): DiagnosticsHealth | undefined {
      return metrics.useEnumValue("diagnostics", "health")
    },
    useFanSpeedsTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("fan_speeds", "timestamp")
    },
    useFanSpeedsPbFan1(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pb_fan1")
    },
    useFanSpeedsPbFan2(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pb_fan2")
    },
    useFanSpeedsPwbFan1(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pwb_fan1")
    },
    useFanSpeedsPwbFan2(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pwb_fan2")
    },
    useFanSpeedsPwbFan3(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pwb_fan3")
    },
    useFanSpeedsPwbFan4(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "pwb_fan4")
    },
    useFanSpeedsTbbFan1(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "tbb_fan1")
    },
    useFanSpeedsTbbFan2(): number | undefined {
      return metrics.useNumberValue("fan_speeds", "tbb_fan2")
    },
    useGnssSatellites(): number | undefined {
      return metrics.useNumberValue("gnss", "satellites")
    },
    useGnssPositionLat(): number | undefined {
      return metrics.useNumberValue("gnss_position", "lat")
    },
    useGnssPositionLon(): number | undefined {
      return metrics.useNumberValue("gnss_position", "lon")
    },
    useLnbInfoSwVersion(): number | undefined {
      return metrics.useNumberValue("lnb_info", "sw_version")
    },
    useLnbInfoHwVersion(): number | undefined {
      return metrics.useNumberValue("lnb_info", "hw_version")
    },
    useLnbInfoSerialNumber(): number | undefined {
      return metrics.useNumberValue("lnb_info", "serial_number")
    },
    useLnbInfoMuted(): boolean | undefined {
      return metrics.useBoolValue("lnb_info", "muted")
    },
    useLnbTelemetriesTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("lnb_telemetries", "timestamp")
    },
    useLnbTelemetriesTempSensor1(): number | undefined {
      return metrics.useNumberValue("lnb_telemetries", "temp_sensor_1")
    },
    useLnbTelemetriesTempSensorCtrl(): number | undefined {
      return metrics.useNumberValue("lnb_telemetries", "temp_sensor_ctrl")
    },
    useLnbTelemetriesVoltage(): number | undefined {
      return metrics.useNumberValue("lnb_telemetries", "voltage")
    },
    useLnbTelemetriesCurrent(): number | undefined {
      return metrics.useNumberValue("lnb_telemetries", "current")
    },
    useModemInfoSerial(): number | undefined {
      return metrics.useNumberValue("modem_info", "serial")
    },
    useModemInfoSoftware(): string | undefined {
      return metrics.useStringValue("modem_info", "software")
    },
    useModemInfoPlatform(): string | undefined {
      return metrics.useStringValue("modem_info", "platform")
    },
    useModemInfoBoard(): string | undefined {
      return metrics.useStringValue("modem_info", "board")
    },
    useModemSignalStrength(): number | undefined {
      return metrics.useNumberValue("modem_signal", "strength")
    },
    useModemStatusStrength(): number | undefined {
      return metrics.useNumberValue("modem_status", "strength")
    },
    useModemStatusRxLocked(): boolean | undefined {
      return metrics.useBoolValue("modem_status", "rx_locked")
    },
    useMotorDiagnosticsAlphaTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("motor_diagnostics_alpha", "timestamp")
    },
    useMotorDiagnosticsAlphaSpeed(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_alpha", "speed")
    },
    useMotorDiagnosticsAlphaCurrent(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_alpha", "current")
    },
    useMotorDiagnosticsAlphaWindingTemp(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_alpha", "winding_temp")
    },
    useMotorDiagnosticsAlphaDriveThermalState(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_alpha", "drive_thermal_state")
    },
    useMotorDiagnosticsAlphaMotorThermalState(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_alpha", "motor_thermal_state")
    },
    useMotorDiagnosticsBetaTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("motor_diagnostics_beta", "timestamp")
    },
    useMotorDiagnosticsBetaSpeed(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_beta", "speed")
    },
    useMotorDiagnosticsBetaCurrent(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_beta", "current")
    },
    useMotorDiagnosticsBetaWindingTemp(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_beta", "winding_temp")
    },
    useMotorDiagnosticsBetaDriveThermalState(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_beta", "drive_thermal_state")
    },
    useMotorDiagnosticsBetaMotorThermalState(): number | undefined {
      return metrics.useNumberValue("motor_diagnostics_beta", "motor_thermal_state")
    },
    useMotorLocalOrientationAlpha(): number | undefined {
      return metrics.useNumberValue("motor_local_orientation", "alpha")
    },
    useMotorLocalOrientationBeta(): number | undefined {
      return metrics.useNumberValue("motor_local_orientation", "beta")
    },
    usePbVoltagesTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("pb_voltages", "timestamp")
    },
    usePbVoltagesDig24v(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "dig_24v")
    },
    usePbVoltagesDig5v(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "dig_5v")
    },
    usePbVoltagesDig3v3(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "dig_3v3")
    },
    usePbVoltagesDig1v8(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "dig_1v8")
    },
    usePbVoltagesDig1v2(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "dig_1v2")
    },
    usePbVoltagesPow5v(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "pow_5v")
    },
    usePbVoltagesPow3v3(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "pow_3v3")
    },
    usePbVoltagesPow48v(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "pow_48v")
    },
    usePbVoltagesPowEpos(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "pow_epos")
    },
    usePbVoltagesPowTbb(): number | undefined {
      return metrics.useNumberValue("pb_voltages", "pow_tbb")
    },
    usePowerDetectorStrength(): number | undefined {
      return metrics.useNumberValue("power_detector", "strength")
    },
    usePwbMetricsTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("pwb_metrics", "timestamp")
    },
    usePwbMetricsPow48v(): number | undefined {
      return metrics.useNumberValue("pwb_metrics", "pow_48v")
    },
    usePwbMetricsPow3v3(): number | undefined {
      return metrics.useNumberValue("pwb_metrics", "pow_3v3")
    },
    usePwbMetricsCurrentSense(): number | undefined {
      return metrics.useNumberValue("pwb_metrics", "current_sense")
    },
    usePwbMetricsEnableOutput(): boolean | undefined {
      return metrics.useBoolValue("pwb_metrics", "enable_output")
    },
    usePwbMetricsFault(): boolean | undefined {
      return metrics.useBoolValue("pwb_metrics", "fault")
    },
    usePwbMetricsButtonPressed(): boolean | undefined {
      return metrics.useBoolValue("pwb_metrics", "button_pressed")
    },
    useSatellitePositionLat(): number | undefined {
      return metrics.useNumberValue("satellite_position", "lat")
    },
    useSatellitePositionLon(): number | undefined {
      return metrics.useNumberValue("satellite_position", "lon")
    },
    useSystemTimeTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("system_time", "timestamp")
    },
    useSoftwareUpdateAvailableStatus(): boolean | undefined {
      return metrics.useBoolValue("software_update_available", "status")
    },
    useTargetLocalOrientationAlpha(): number | undefined {
      return metrics.useNumberValue("target_local_orientation", "alpha")
    },
    useTargetLocalOrientationBeta(): number | undefined {
      return metrics.useNumberValue("target_local_orientation", "beta")
    },
    useTargetLocalOrientationGamma(): number | undefined {
      return metrics.useNumberValue("target_local_orientation", "gamma")
    },
    useTargetOrientationAzimuth(): number | undefined {
      return metrics.useNumberValue("target_orientation", "azimuth")
    },
    useTargetOrientationElevation(): number | undefined {
      return metrics.useNumberValue("target_orientation", "elevation")
    },
    useTargetOrientationPolarization(): number | undefined {
      return metrics.useNumberValue("target_orientation", "polarization")
    },
    useTbbMetricsTimestamp(): dayjs.Dayjs | undefined {
      return metrics.useTimestampValue("tbb_metrics", "timestamp")
    },
    useTbbMetricsPow48v(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "pow_48v")
    },
    useTbbMetricsPow25v(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "pow_25v")
    },
    useTbbMetricsPow12v(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "pow_12v")
    },
    useTbbMetricsPow3v3(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "pow_3v3")
    },
    useTbbMetricsCurrentSense(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "current_sense")
    },
    useTbbMetricsBucCurrent(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "buc_current")
    },
    useTbbMetricsLnbCurrent(): number | undefined {
      return metrics.useNumberValue("tbb_metrics", "lnb_current")
    },
  }
}

function toLogLevel(logLevel: string): LogLevel {
  switch (logLevel) {
    case "emergency":
      return "error"
    case "alert":
      return "error"
    case "critical":
      return "error"
    case "error":
      return "error"
    case "warning":
      return "warning"
    case "notice":
      return "warning"
    case "informational":
      return "info"
    case "debug":
      return "info"
  }
  return "info"
}

function fromLogLevel(logLevel: LogLevel): string[] {
  switch (logLevel) {
    case "info":
      return ["informational", "debug"]
    case "warning":
      return ["warning", "notice"]
    case "error":
      return ["emergency", "alert", "critical", "error"]
  }
}
export const logLevelMapper: LogLevelMapper = { toLogLevel, fromLogLevel }
